export default {"src":"/evde-internet/_next/static/media/Signal.5fa6fbfd.svg","height":24,"width":24};